module.exports = __webpack_public_path__ + "img/ru-baa-ruu.2a8f0d72.png";